import React, { useEffect, useState } from 'react';
import { BuroPortal, mensajeError } from './helpers';
import { buroApi } from './api';
import { BuroCombobox } from './BuroCombobox';

/*
 * Panel para capturar la config del reporte PM/PFAE que hoy falta para poder
 * cerrar: clave de usuario (HD00), tipo de institución (HD02), nombre del
 * otorgante (HD07) y las dos confirmaciones (tipos de crédito con Buró, y
 * criterios contables). Son datos que se acuerdan con Buró / Contabilidad; se
 * guardan en BD (ya no en el .env) vía /buro-reportes/config-pm.
 *
 * props:
 *   onClose    cerrar el panel
 *   onGuardado (estado) → avisa a la tabla para refrescar el reporte y sus pendientes
 */
// HD02: el manual de Buró Empresas v5 lista 16 tipos de institución (banco, factoraje, seguros…);
// el sistema solo acepta estos dos, que son los que corresponden a PEICAR.
const TIPOS = [
  { value: '002', label: '002 · Arrendadora', detalle: 'Arrendadora: empresa que otorga arrendamiento (puro o financiero).' },
  { value: '005', label: '005 · Otras financieras', detalle: 'Otras financieras: entidad financiera que no es banco, arrendadora, unión de crédito ni factoraje. El ejemplo de encabezado del manual usa 005.' },
];
const OPCIONES_TIPO = TIPOS.map(({ value, label }) => ({ value, label }));
const SIN_TIPO = [{ value: '', label: '— Sin definir —' }];

export const BuroConfigPm = ({ onClose, onGuardado }) => {
  const [form, setForm] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState(null);
  const [ok, setOk] = useState(false);

  useEffect(() => {
    const ctrl = new AbortController();
    buroApi.getConfigPm(ctrl.signal)
      .then((d) => setForm({
        clave_usuario: d.clave_usuario || '',
        tipo_institucion: d.tipo_institucion || '',
        nombre_otorgante: d.nombre_otorgante || '',
        tipos_credito_confirmados: !!d.tipos_credito_confirmados,
        criterios_contables_confirmados: !!d.criterios_contables_confirmados,
      }))
      .catch((e) => { if (!ctrl.signal.aborted) setError(mensajeError(e, 'No se pudo cargar la configuración.')); })
      .finally(() => { if (!ctrl.signal.aborted) setCargando(false); });
    return () => ctrl.abort();
  }, []);

  const set = (k, v) => { setForm((f) => ({ ...f, [k]: v })); setOk(false); };

  const guardar = () => {
    setGuardando(true);
    setError(null);
    buroApi.guardarConfigPm(form)
      .then((estado) => { setOk(true); onGuardado?.(estado); })
      .catch((e) => setError(mensajeError(e, 'No se pudo guardar la configuración.')))
      .finally(() => setGuardando(false));
  };

  return <BuroPortal><div className="bu-panel" style={{ width: 480 }}>
    <div className="bu-panel-head">
      <div style={{ flex: 1 }}>
        <h3 style={{ margin: 0 }}>Datos de Buró para cerrar</h3>
        <div className="s">Clave de usuario, tipo de institución y confirmaciones. Se acuerdan con Buró y Contabilidad.</div>
      </div>
      <button type="button" className="bu-btn" onClick={onClose}>Cerrar</button>
    </div>
    <div className="bu-panel-body">
      {error && <div role="alert" className="bu-note bu-note-err"><i className="pi pi-exclamation-triangle" /><span>{error}</span></div>}
      {ok && <div className="bu-note bu-note-ok"><i className="pi pi-check-circle" /><span>Guardado.</span></div>}
      {cargando || !form ? (
        <div className="bu-sub">Cargando…</div>
      ) : (
        <>
          <label className="bu-field">
            <span className="bu-label">Clave del usuario · HD00</span>
            <input className="bu-input" inputMode="numeric" maxLength={4} placeholder="4 dígitos"
              value={form.clave_usuario} disabled={guardando}
              onChange={(e) => set('clave_usuario', e.target.value.replace(/\D/g, '').slice(0, 4))} />
            <span className="bu-sub" style={{ fontSize: 12 }}>La clave de 4 dígitos que asigna Buró.</span>
          </label>
          <label className="bu-field">
            <span className="bu-label">Tipo de institución · HD02</span>
            <BuroCombobox
              ariaLabel="Tipo de institución"
              placeholder="Elegir tipo de institución…"
              options={OPCIONES_TIPO}
              fijas={SIN_TIPO}
              value={form.tipo_institucion}
              disabled={guardando}
              onChange={(v) => set('tipo_institucion', v)}
            />
            <span className="bu-sub" style={{ fontSize: 12 }}>
              {TIPOS.find((t) => t.value === form.tipo_institucion)?.detalle || 'Elige el tipo con el que Buró da de alta a la empresa: 002 Arrendadora o 005 Otras financieras.'}
            </span>
          </label>
          <label className="bu-field">
            <span className="bu-label">Nombre del otorgante · HD07</span>
            <input className="bu-input" maxLength={75} value={form.nombre_otorgante} disabled={guardando}
              onChange={(e) => set('nombre_otorgante', e.target.value)} />
            <span className="bu-sub" style={{ fontSize: 12 }}>El nombre corto de la razón social como está registrado en Buró Empresas (hasta 75 caracteres).</span>
          </label>
          <label className="bu-check">
            <input type="checkbox" checked={form.tipos_credito_confirmados} disabled={guardando}
              onChange={(e) => set('tipos_credito_confirmados', e.target.checked)} />
            Tipos de crédito PM confirmados con Buró
          </label>
          <label className="bu-check">
            <input type="checkbox" checked={form.criterios_contables_confirmados} disabled={guardando}
              onChange={(e) => set('criterios_contables_confirmados', e.target.checked)} />
            IVA, capital, interés y fecha de cartera vencida confirmados con Contabilidad
          </label>
        </>
      )}
    </div>
    <div className="bu-panel-foot">
      <button type="button" className="bu-btn" onClick={onClose}>Cancelar</button>
      <button type="button" className="bu-btn bu-btn-primary" disabled={guardando || cargando || !form} onClick={guardar}>
        {guardando ? 'Guardando…' : 'Guardar'}
      </button>
    </div>
  </div></BuroPortal>;
};
